import React, { useMemo, useState,useEffect } from 'react'
import { get } from 'lodash'
// import { useWindowSizes } from '@hooks/window'
// import Select from 'react-select'
// import countryList from 'react-select-country-list'
import HubspotForm from 'react-hubspot-form'
// import * as styles from '../../styles/partials/_hubspot.css'
import { Strings } from '../../utils/strings'

const PdpRequestSample = ({ data, toggleSampleForm, state }) => {

  // const hubspotForm = useRef(null)
  // const [formCurrentLocation, setFormCurrentLocation] = useState('')

  // console.log('[PdpRequestSample.js] data', data)

  // const family_name = useMemo(() => (
  //   get(data, 'family.title[0].text')
  // ), [data])

  // const title = useMemo(() => (
  //   get(signupModalData, 'title[0].text')
  // ), [signupModalData])

  const allStrings = Strings(data)

  const formTitle = useMemo(() => (
    get(data, 'form_title[0].text', 'Order a Sample')
  ), [data])

  const formIntro = useMemo(() => (
    get(data, 'form_intro[0].text')
  ), [data])

  // const portalId = useMemo(() => (
  //   get(data, 'hubspot_portal_id', '8833363')
  // ), [data])

  // const formId = useMemo(() => (
  //   get(data, 'hubspot_form_id', '81d8ef80-0e14-4208-93c4-f0ce6c6db684')
  // ), [data])

  const body1 = useMemo(() => (
    get(data, 'body1')
  ), [data])

  let showButton
  if(body1?.length > 1) {
    showButton = " show"
  } else {
    showButton = ""
  }

  const first_location = useMemo(() => (
    get(data, 'body1[0].primary.target_location')
  ), [data])


  // console.log('first_location', first_location)

  const [formCurrentLocation, setFormCurrentLocation] = useState(first_location)

  useEffect(() => {
    setFormCurrentLocation(first_location)
    // console.log('useEffect', first_location)
  }, [first_location]);

  // const options = useMemo(() => countryList().getData(), [])

  // console.log('HubspotStyle', HubspotStyle)

  // console.log('hubstyles', styles.body)

  // const loadHubspotCSS = (ev) => {

  //   // const styles = {
  //   //   backgroundColor: "lightblue"
  //   // }

  //   // const new_style_element = document.createElement("style");
  //   // new_style_element.textContent = ".my-class { display: none; }"
  //   // ev.target.contentDocument.head.appendChild(new_style_element);

  //   return null
  // }

  // const [locations, setLocations] = useState([])

  const renderForm = (form, index) => {

    if (form && form.type === "sample_form") {
      const hubspot_portal_id = get(form, 'primary.hubspot_portal_id1')
      const hubspot_form_id = get(form, 'primary.hubspot_form_id1')
      const target_location = get(form, 'primary.target_location')
      
      if(formCurrentLocation === target_location) {
        return (
          <div className="signin-form" key={index}>
            {hubspot_form_id && hubspot_portal_id ? 
              <HubspotForm
                portalId={hubspot_portal_id}
                formId={hubspot_form_id}
                onSubmit={() => {}}
                onReady={(form) => {}}
                // onLoad={loadHubspotCSS()}
                // loading={<div className="loader"></div>}
                // ref={hubspotForm}
                // loading={<div className="loader"><img src={loader} alt="loader" /></div>}
              />
            : null}
          </div>
        )
      }
    }

    return []
  }

  const [locationButtonState, setLocationButtonState] = useState('')
  const togglesetLocationButton = () => {
    // setSortButtonState(!sortButtonState)
    if(locationButtonState === '') {
      setLocationButtonState(' open')
    } else {
      setLocationButtonState('')
    }
  }
  
  const renderLocationLink = (location, index) => {
    const target_location = get(location, 'primary.target_location')

    console.log('renderLocationLink target_location', target_location)

    // if(index === 0 && formCurrentLocation === '') {
    //   // setLocations([target_location])
    //   setFormCurrentLocation(target_location)
    // }

    return (
      <li 
        key={index} 
        className={target_location === formCurrentLocation ? 'active' : ''}
        tabIndex="0" 
        onKeyDown={() => setFormCurrentLocation(target_location)} 
        onClick={() => {
          setFormCurrentLocation(target_location)
          setLocationButtonState('')
        }} 
        role="button">
        <span className="btn-dropdown__items__square"></span>
        {target_location}
      </li>
    )
  }

  return(
    <section className={"pdp_request_sample"+state}>
      <div 
        className="pdp_request_sample__left" 
        onClick={() => {toggleSampleForm()}}
        onKeyDown={() => toggleSampleForm()}
        role="button"
        tabIndex="0">  
      </div>
      <div className="pdp_request_sample__container">
        <div className="pdp_request_sample__inner">
          <div className="pdp_request_sample__header">
            <h4>{formTitle}</h4>
            <button 
              className="pdp_request_sample__close"
              onClick={() => {toggleSampleForm()}}>
            </button>
          </div>
          
          <p className="pdp_request_sample__descrition p-medium font-book">
            {formIntro}
          </p>

          <div className={"legal_pages__location_button pdp_request_sample__location_btn"+showButton}>
            <h4 className="p-large legal_pages__location_button__title">
              {allStrings?.sample_location_selector ?? 'Choose a shipping location'}:
            </h4>
            <div 
              className={"legal_pages__location_button__btn btn-dropdown"+locationButtonState}>
              <div 
                tabIndex="0" 
                className="btn-dropdown__name" 
                onKeyDown={() => togglesetLocationButton()} 
                onClick={() => togglesetLocationButton()} 
                role="button"
              >
                {formCurrentLocation}
              </div>
              <ul className="btn-dropdown__items">
                {body1 && body1.map((location, index) => (
                  renderLocationLink(location, index)
                ))}
              </ul>
            </div>
          </div>

          {body1 && body1.map((form, index) => (
            renderForm(form, index)
          ))}
          {/* <div className="signin-form">
            

            {portalId && formId ? 
              <HubspotForm
                portalId={portalId}
                formId={formId}
                onSubmit={() => {}}
                onReady={(form) => {}}
                // onLoad={loadHubspotCSS()}
                // loading={<div className="loader"></div>}
                // ref={hubspotForm}
                // loading={<div className="loader"><img src={loader} alt="loader" /></div>}
              />
            : null}
          </div> */}

          {/* <form>

            <div className="input_field input_field-double">
              <fieldset>
                <label>First Name</label>
                <input name="first_name" type="text" />
              </fieldset>
              <fieldset>
                <label>Last Name</label>
                <input name="last_name" type="email" />
              </fieldset>
            </div>

            <div className="input_field">
              <fieldset>
                <label>Email Address</label>
                <input name="email_address" type="email" />
              </fieldset>
            </div>

            <div className="input_field">
              <fieldset>
                <label>Country</label>
                <Select 
                  options={options}
                  menuIsOpen={true}
                  classNamePrefix="react_select" />
              </fieldset>
            </div>

            <div className="input_field">
              <fieldset>
                <label>Address</label>
                <input name="address" type="text" />
              </fieldset>
            </div>

            <div className="input_field input_field-double">
              <fieldset>
                <label>City</label>
                <input name="city" type="text" />
              </fieldset>
              <fieldset>
                <label>State/Region</label>
                <input name="state_region" type="email" />
              </fieldset>
            </div>

            <div className="input_field input_field-double">
              <fieldset>
                <label>Postal or Zip Code</label>
                <input name="zip_code" type="text" />
              </fieldset>
              <fieldset>
                <label>Phone</label>
                <input name="phone" type="email" />
              </fieldset>
            </div>

            <button className="btn-secondary black pdp_request_sample__submit">
              Request Sample
            </button>


          </form> */}

        </div>
      </div>
      
    </section>
    
  )  
}

export default PdpRequestSample
